import React from 'react'
import { CFooter } from '@coreui/react'

const getCurrentJalaliYear = () => {
  const persianYear = new Intl.DateTimeFormat('fa-IR-u-ca-persian', { year: 'numeric' }).format(new Date())
  const englishDigits = persianYear.replace(/[۰-۹]/g, (digit) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))
  return Number(englishDigits)
}

const AppFooter = () => {
  const currentJalaliYear = getCurrentJalaliYear()

  return (
    <CFooter style={{ justifyContent: 'center', alignItems: 'center' }}>

      {/* <a href="https://coreui.io" target="_blank" rel="noopener noreferrer">
          CoreUI
        </a>
        <span className="ms-1">&copy; 2022 creativeLabs.</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        <a href="https://coreui.io/react" target="_blank" rel="noopener noreferrer">
          CoreUI React Admin &amp; Dashboard Template
        </a> */}
      <span>کلیه حقوق برای باشگاه کوهنوردی و اسکی دماوند محفوظ است {currentJalaliYear}</span>

    </CFooter>
  )
}

export default React.memo(AppFooter)
